export const GET_ALL_USER: string = "GET_ALL_USER";
export const GET_ONE_USER: string = "GET_ONE_USER";
export const LOADING: string = "LOADING";
export const USER_ATTENDANCE: string = "USER_ATTENDANCE";
export const USER_LOGS: string = "USER_LOGS";
export const USER_ADD_LOGS: string = "USER_ADD_LOGS";

// export const UPDATE_USER_PROFILE:string ="UPDATE_USER_PROFILE";
// export const UPDATE_USER_PASSWORD:string ="UPDATE_USER_PASSWORD";
